import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import './WhatsAppManagerDeleteModal.scss';

const WhatsAppManagerDeleteModal = ({ show, manager, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error('Error deleting manager:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered className="wa-manager-delete-modal">
      <Modal.Header closeButton>
        <Modal.Title>Remove WhatsApp Manager</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="confirmation-section">
          <div className="warning-icon-container">
            <i className="fas fa-exclamation-triangle warning-icon"></i>
          </div>
          <h5 className="confirmation-title">Are you sure?</h5>
          <p className="confirmation-text">
            You are about to remove <strong>{manager?.name}</strong> ({manager?.email}) 
            as a WhatsApp manager.
          </p>
        </div>

        <div className="action-list">
          <h6 className="action-list-title">This action will:</h6>
          <ul className="action-items">
            <li>Remove their WhatsApp manager profile</li>
            <li>Unassign all their agents</li>
            <li>Remove access to manager features</li>
            <li>Cannot be undone</li>
          </ul>
        </div>

        <div className="manager-details">
          <h6 className="details-title">Manager Details</h6>
          <div className="details-grid">
            <div className="detail-item">
              <span className="detail-label">Name:</span>
              <span className="detail-value">{manager?.name || 'N/A'}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Email:</span>
              <span className="detail-value">{manager?.email || 'N/A'}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Type:</span>
              <span className="detail-value">{manager?.manager_type?.toUpperCase() || 'N/A'}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Current Agents:</span>
              <span className="detail-value">{manager?.current_agents_count || 0}</span>
            </div>
          </div>
        </div>

        {manager?.current_agents_count > 0 && (
          <div className="danger-warning">
            <div className="danger-icon-container">
              <i className="fas fa-exclamation-circle danger-icon"></i>
            </div>
            <div className="danger-content">
              <strong>Warning:</strong> This manager currently has {manager.current_agents_count} 
              assigned agent(s). Removing this manager will unassign all their agents and may 
              affect ongoing conversations.
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading} className="cancel-btn">
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={loading} className="remove-btn">
          {loading ? 'Removing...' : 'Remove Manager'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WhatsAppManagerDeleteModal;